import io from 'socket.io-client';

const clientInfo = JSON.parse(localStorage.getItem('clientInfo'));

// export const socket = io("http://192.168.201.87:8080/websockt-server-site", {
export const socket = io("https://www.pagtel.com.br/websockt-server-site", { // TODO: ADICIONAR EM PROD

    // const socket = io("https://www.pagtel.com.br/websocket-server", {
    transports: ["websocket"],
    path: "/socket-site.io", //TODO: ADICIONAR EM PROD
    extraHeaders: {
        Authorization: clientInfo?.accessToken,
    },
    // reconnection: false,
    // reconnectionAttempts: 3,
    // rememberTransport: false
});